<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
          <el-row>
            <el-col :span="6">
              <el-input size="medium" placeholder="搜索关键字: 标题" v-model="key" style="width: 97%;"></el-input>
            </el-col>
            <el-col :span="7">
              <el-button size="medium" type="primary" icon="el-icon-search" @click="searchPushList">搜索</el-button>
            </el-col>
            <el-col :span="9">
              &nbsp;
            </el-col>
            <el-col :span="2">
              &nbsp;
              <el-button size="medium" type="primary" @click="openDialog('add', null)">新增</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <el-table :data="tableData" border fixed height="400" style="width: 100%">
          <el-table-column prop="title" label="标题" min-width="70"></el-table-column>
          <el-table-column prop="image" label="图片" min-width="50">
            <template slot-scope="scope">
              <img :src="scope.row.image"  min-width="60" height="50"  alt="无法加载图片"/>
            </template>
            <!-- <image-view :url="{}" :srcList="{}"></image-view> -->
          </el-table-column>
          <el-table-column prop="pushTime" label="推送时间" min-width="70"></el-table-column>
          <!-- <el-table-column prop="giftDescription" label="推送端" min-width="70"></el-table-column> -->
          <el-table-column prop="pushTerminal" label="推送端" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.pushTerminal == 'wechat'">微信端</span>
              <span v-else-if="scope.row.pushTerminal == 'sms'">短信端</span>
              <!-- <span v-else-if="scope.row.status == 2">已取消</span> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="applyTime" label="申请时间" min-width="140"></el-table-column> -->
          <!-- <el-table-column prop="userName" label="操作人" min-width="70"></el-table-column>
          <el-table-column prop="createTime" label="操作时间" min-width="70"></el-table-column> -->
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-button @click="viewDialog('search',scope.row)" type="success" size="mini" >
                查看
              </el-button>
              <el-button @click="deletePush(scope.row.pushId)" type="danger" size="mini">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination
            background
            @current-change="currentPageChange"
            @size-change="pageSizeChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="pageSize"
            :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog :title="pushDialogTitle + '推送信息'"
               :visible.sync="dialogVisible"
               :modal="false"
      :close-on-click-modal="false"
               @closed="resetForm('pushForm')"
               @open="openDialogEvent(addFlag)" >
      <el-form :model="pushForm"
               ref="giftOrderExchangeForm"
               :rules="pushMgtFormRules"
               label-width="120px"
               size="medium"
               style="padding: 0 10%;" >
        <el-form-item label="标题" prop="title">
          <el-input v-model="pushForm.title" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="图片" prop="image">
           <el-input type='file' v-model="pushForm.image" clearable></el-input>
        </el-form-item> -->
       
        <el-form-item label="推送时间" prop="pushTime">
          <!-- <el-input v-model="pushForm.pushTime" clearable></el-input> -->
          <el-date-picker
              v-model="pushForm.pushTime"
              type="datetime"
              placeholder="选择日期时间" 
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="推送端" prop="pushTerminal">
          <!-- <el-input v-model="pushForm.pushTerminal" clearable></el-input> -->
          <el-select v-model="pushForm.pushTerminal" clearable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="pushForm.createTime" clearable readonly></el-input>
        </el-form-item>
         <el-form-item label="图片" prop="image">
          <upload-push ></upload-push>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type='textarea'  :autosize="{minRows:5,maxRows:7}" v-model="pushForm.content" clearable></el-input>
        </el-form-item>
        <el-form-item size="large">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary" @click="submitForm('pushForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
    import uploadPush from "./component/upload"
    import imageView from "./component/image-view"
    export default {
        name: "pushList",
        components: {
            uploadPush,
            imageView,
        },
        data() {
            return {
                options: [{
                  value: 'sms',
                  label: '短信端'
                }, {
                  value: 'wechat',
                  label: '微信端'
                }],
                value:"",
                key: '',
                addFlag: 'add',
                tableData: [],
                currentPage: 1,
                pageSize: 20,
                totalPage: 100,
                total: 100000,
                dialogVisible: false,
                pushDialogTitle: '',
                pushForm: {
                  pushId:"",
                  title:"",
                  image:"",
                  pushTime:"",
                  pushTerminal:"",
                  createTime:"",
                  content : "",                  
                },
                pushMgtFormRules: {},
            }
        },
        created() {
            this.searchPushList();
        },
        methods: {
            searchPushList() {
                let reqParam = {
                    title: this.key,
                    size: this.pageSize,
                    currentPage: this.currentPage,
                };
                this.$http.post('/api/push-mgt-service/pushmgt/search', reqParam).then(resp => {
                    console.log(resp);
                    let data = resp.data;
                    if ("success" === data.code) {
                        let pageInfo = data.data;
                        this.tableData = pageInfo.list;
                        this.pageSize = pageInfo.pageSize;
                        this.total = pageInfo.total;
                        this.totalPage = pageInfo.pages;
                        console.log("--->   "+ pageInfo.list);
                    } else {
                        this.$alert('' + data.message, '温馨提示', {
                            confirmButtonText: '确定'
                        });
                    }
                }).catch(response => {
                    this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                        confirmButtonText: '确定'
                    });
                })
            },
            // 删除推送信息
            deletePush(pushId) {
                this.$confirm('此操作将永久删除, 是否继续?', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get('/api/push-mgt-service/pushmgt/del?pushId=' + pushId).then(resp => {
                        let data = resp.data;
                        if (data.code === "success") {
                            this.dialogVisible = false;
                            this.$message({
                                message: '删除推送信息成功',
                                type: 'success'
                            });
                            this.searchPushList();
                        } else {
                            this.$alert(''  + data.message, '温馨提示', {
                                confirmButtonText: '确定'
                            });
                        }
                    }).catch(e => {
                        this.$alert(''  + e, '温馨提示', {
                            confirmButtonText: '确定'
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            viewDialog(addFlag, data) {
                this.dialogVisible = true;
                this.pushDialogTitle = "查看";
                this.pushForm = data
                console.log(" data: "+ data);
            },
            openDialog(addFlag, data) {
                this.dialogVisible = true;
                this.pushDialogTitle = "新增";
                console.log("新增 data: "+ data);
                this.formatDate();
                
            },
            submitForm(formName) {
               let reqParam = {
                  title:this.pushForm.title,
                  image:this.pushForm.image,
                  pushTime:this.pushForm.pushTime,
                  pushTerminal:this.pushForm.pushTerminal,
                  createTime:this.pushForm.createTime,
                  content : this.pushForm.content,
               };
              //  console.log(pushForm);
               this.$http.post('/api/push-mgt-service/pushmgt/add', reqParam).then(resp => {
                    console.log(resp);
                    let data = resp.data;
                    if ("success" === data.code) {
                        this.$alert('' + data.message, '温馨提示', {
                            confirmButtonText: '确定'
                        });
                        this.dialogVisible = false;
                    } else {
                        this.$alert('' + data.message, '温馨提示', {
                            confirmButtonText: '确定'
                        });
                    }
                }).catch(response => {
                    this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
                        confirmButtonText: '确定'
                    });
                })
            },
            openDialogEvent(addFlag){
                
            },
            currentPageChange(val) {
                this.currentPage = val;
                this.searchUser();
            },
            pageSizeChange(val) {
                this.pageSize = val;
                this.searchUser();
            },
            resetForm(formName) {
                this.integralForm = {};
                this.$refs[formName].resetFields();
            },
            formatDate(){
               var aData = new Date();
              console.log(aData) //Wed Aug 21 2019 10:00:58 GMT+0800 (中国标准时间)
    
              this.pushForm.createTime = aData.getFullYear() + "-" + (aData.getMonth() + 1) + "-" + aData.getDate() +
              " "+aData.getHours() + ':'
              + aData.getMinutes() + ':'
              + aData.getSeconds();
              console.log(this.value) //2019-8-20 
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/push/pushList.vue